/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.ar-transfer-payment-editor-content[_ngcontent-%COMP%]   .add-button-container[_ngcontent-%COMP%]{width:100%;text-align:right;padding-bottom:5px}.ar-transfer-payment-editor-content[_ngcontent-%COMP%]   .total-tansfer[_ngcontent-%COMP%]{padding-top:10px;padding-bottom:10px}"];
export { styles as styles };
